module.exports = __webpack_public_path__ + "static/media/tablet.7db20bc5.svg";